export interface Product {
  id: string;
  name: string;
  slug: string;
  category: string;
  price: number;
  originalPrice: number;
  imageUrl: string;
  imageWidth: number;
  imageHeight: number;
  imageSeq: string;
  imageQuery: string;
  description: string;
  tags: string[];
  rating: number;
  reviewCount: number;
  featured: boolean;
  inStock: boolean;
  createdAt: string;
}

export const products: Product[] = [
  {
    id: 'p001',
    name: '北欧极简实木餐桌',
    slug: 'nordic-minimalist-wooden-dining-table',
    category: '家居好物',
    price: 3299,
    originalPrice: 4599,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20Nordic%20minimalist%20solid%20wood%20dining%20table%20with%20clean%20lines%2C%20warm%20oak%20finish%2C%20set%20in%20a%20bright%20modern%20dining%20room%20with%20soft%20natural%20light%2C%20simple%20elegant%20Scandinavian%20design%2C%20product%20photography%20on%20white%20backdrop%20with%20soft%20shadows&width=800&height=800&seq=product-p001&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p001',
    imageQuery: 'A Nordic minimalist solid wood dining table with clean lines, warm oak finish, set in a bright modern dining room with soft natural light, simple elegant Scandinavian design, product photography on white backdrop with soft shadows',
    description: '精选北美白橡木打造，简约北欧设计，线条流畅自然。每一块木材均经72道工序精制，确保经久耐用。',
    tags: ['实木', '北欧', '餐桌', '热销'],
    rating: 4.9,
    reviewCount: 326,
    featured: true,
    inStock: true,
    createdAt: '2026-05-15',
  },
  {
    id: 'p002',
    name: '手工陶瓷香薰灯',
    slug: 'handmade-ceramic-aroma-lamp',
    category: '家居好物',
    price: 468,
    originalPrice: 599,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20handmade%20ceramic%20essential%20oil%20aromatherapy%20diffuser%20lamp%20with%20warm%20glowing%20light%2C%20elegant%20matte%20white%20ceramic%20finish%2C%20minimalist%20design%20with%20soft%20ambient%20glow%2C%20product%20photography%20on%20cream%20background%20with%20gentle%20shadows&width=800&height=800&seq=product-p002&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p002',
    imageQuery: 'A handmade ceramic essential oil aromatherapy diffuser lamp with warm glowing light, elegant matte white ceramic finish, minimalist design with soft ambient glow, product photography on cream background with gentle shadows',
    description: '手工拉坯成型，细腻陶瓷质感。搭配天然精油使用，营造温馨舒适的家居氛围。每件均为匠人独立制作。',
    tags: ['手工', '陶瓷', '香薰', '氛围灯'],
    rating: 4.8,
    reviewCount: 189,
    featured: true,
    inStock: true,
    createdAt: '2026-06-02',
  },
  {
    id: 'p003',
    name: '真丝缎面枕套套装',
    slug: 'silk-satin-pillowcase-set',
    category: '家居好物',
    price: 368,
    originalPrice: 499,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20set%20of%20luxurious%20pure%20silk%20pillowcases%20in%20champagne%20gold%20color%2C%20smooth%20satin%20finish%20with%20subtle%20sheen%2C%20elegantly%20draped%20on%20a%20bed%20with%20soft%20morning%20light%2C%20product%20photography%20with%20clean%20aesthetic&width=800&height=800&seq=product-p003&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p003',
    imageQuery: 'A set of luxurious pure silk pillowcases in champagne gold color, smooth satin finish with subtle sheen, elegantly draped on a bed with soft morning light, product photography with clean aesthetic',
    description: '100%桑蚕丝面料，22姆米重磅真丝。天然蛋白纤维呵护肌肤与秀发，减少睡眠摩擦，享受丝滑睡眠体验。',
    tags: ['真丝', '枕套', '睡眠', '护肤'],
    rating: 4.7,
    reviewCount: 512,
    featured: true,
    inStock: true,
    createdAt: '2026-04-20',
  },
  {
    id: 'p004',
    name: '意大利手工牛皮托特包',
    slug: 'italian-leather-tote-bag',
    category: '时尚精品',
    price: 2899,
    originalPrice: 3699,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxurious%20Italian%20handcrafted%20full-grain%20leather%20tote%20bag%20in%20cognac%20brown%2C%20minimalist%20design%20with%20clean%20stitching%2C%20elegant%20hardware%20details%2C%20product%20photography%20on%20warm%20beige%20backdrop%20with%20soft%20lighting&width=800&height=800&seq=product-p004&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p004',
    imageQuery: 'A luxurious Italian handcrafted full-grain leather tote bag in cognac brown, minimalist design with clean stitching, elegant hardware details, product photography on warm beige backdrop with soft lighting',
    description: '意大利托斯卡纳全粒面牛皮，由拥有30年经验的老匠人手工缝制。简约大气，容量充足，日常通勤与休闲皆宜。',
    tags: ['真皮', '手工', '意大利', '托特包'],
    rating: 4.9,
    reviewCount: 203,
    featured: true,
    inStock: true,
    createdAt: '2026-05-28',
  },
  {
    id: 'p005',
    name: '羊绒混纺围巾披肩',
    slug: 'cashmere-blend-scarf-shawl',
    category: '时尚精品',
    price: 698,
    originalPrice: 899,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20soft%20cashmere%20blend%20scarf%20shawl%20in%20warm%20oatmeal%20beige%20color%2C%20delicate%20knit%20texture%20with%20elegant%20drape%2C%20styled%20on%20a%20mannequin%20with%20natural%20lighting%2C%20product%20photography%20with%20warm%20autumn%20aesthetic&width=800&height=800&seq=product-p005&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p005',
    imageQuery: 'A soft cashmere blend scarf shawl in warm oatmeal beige color, delicate knit texture with elegant drape, styled on a mannequin with natural lighting, product photography with warm autumn aesthetic',
    description: '精选内蒙古优质羊绒与美利奴羊毛混纺，手感柔软细腻，轻盈保暖。经典燕麦色，百搭不挑人。',
    tags: ['羊绒', '围巾', '披肩', '秋冬'],
    rating: 4.8,
    reviewCount: 178,
    featured: false,
    inStock: true,
    createdAt: '2026-03-10',
  },
  {
    id: 'p006',
    name: '日式简约纯银锁骨链',
    slug: 'japanese-silver-collarbone-necklace',
    category: '时尚精品',
    price: 528,
    originalPrice: 699,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20delicate%20Japanese%20minimalist%20sterling%20silver%20collarbone%20necklace%20with%20a%20tiny%20cherry%20blossom%20pendant%2C%20fine%20chain%20with%20subtle%20sparkle%2C%20displayed%20on%20a%20velvet%20jewelry%20display%2C%20product%20photography%20with%20soft%20diffused%20light&width=800&height=800&seq=product-p006&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p006',
    imageQuery: 'A delicate Japanese minimalist sterling silver collarbone necklace with a tiny cherry blossom pendant, fine chain with subtle sparkle, displayed on a velvet jewelry display, product photography with soft diffused light',
    description: '925纯银材质，日式极简设计。精巧樱花吊坠点缀，低调优雅中见细节之美。适合日常佩戴与送礼。',
    tags: ['纯银', '项链', '日式', '简约'],
    rating: 4.7,
    reviewCount: 256,
    featured: false,
    inStock: true,
    createdAt: '2026-06-15',
  },
  {
    id: 'p007',
    name: '日本手工铸铁茶壶',
    slug: 'japanese-iron-teapot',
    category: '家居好物',
    price: 1280,
    originalPrice: 1680,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20traditional%20Japanese%20handcrafted%20cast%20iron%20teapot%20with%20intricate%20texture%20pattern%2C%20dark%20iron%20finish%2C%20displayed%20on%20a%20wooden%20tea%20tray%20with%20bamboo%20accessories%2C%20product%20photography%20with%20zen%20aesthetic&width=800&height=800&seq=product-p007&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p007',
    imageQuery: 'A traditional Japanese handcrafted cast iron teapot with intricate texture pattern, dark iron finish, displayed on a wooden tea tray with bamboo accessories, product photography with zen aesthetic',
    description: '日本南部铁器传统工艺，纯手工铸造。煮水甘甜，保温持久，在品茶中感受匠人精神与东方美学。',
    tags: ['铁壶', '日本', '茶具', '手工'],
    rating: 4.9,
    reviewCount: 98,
    featured: true,
    inStock: true,
    createdAt: '2026-04-08',
  },
  {
    id: 'p008',
    name: '有机棉麻家居服套装',
    slug: 'organic-linen-homewear-set',
    category: '生活优选',
    price: 459,
    originalPrice: 599,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20comfortable%20organic%20cotton%20linen%20blend%20loungewear%20set%20in%20natural%20cream%20color%2C%20relaxed%20fit%20with%20subtle%20texture%2C%20styled%20in%20a%20cozy%20sunlit%20bedroom%2C%20product%20photography%20with%20warm%20natural%20light&width=800&height=800&seq=product-p008&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p008',
    imageQuery: 'A comfortable organic cotton linen blend loungewear set in natural cream color, relaxed fit with subtle texture, styled in a cozy sunlit bedroom, product photography with warm natural light',
    description: '有机棉与天然亚麻混纺面料，透气亲肤，自在舒适。宽松版型设计，居家与睡眠的最佳伴侣。',
    tags: ['有机棉', '家居服', '舒适', '天然'],
    rating: 4.8,
    reviewCount: 345,
    featured: false,
    inStock: true,
    createdAt: '2026-05-01',
  },
  {
    id: 'p009',
    name: '便携折叠瑜伽垫',
    slug: 'portable-folding-yoga-mat',
    category: '生活优选',
    price: 328,
    originalPrice: 429,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20premium%20portable%20foldable%20yoga%20mat%20in%20natural%20cork%20texture%20with%20carrying%20strap%2C%20neatly%20folded%20alongside%20a%20plant%20in%20a%20bright%20minimalist%20room%2C%20product%20photography%20with%20clean%20composition&width=800&height=800&seq=product-p009&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p009',
    imageQuery: 'A premium portable foldable yoga mat in natural cork texture with carrying strap, neatly folded alongside a plant in a bright minimalist room, product photography with clean composition',
    description: '天然软木+TPE环保材质，防滑耐磨。可折叠设计，轻松收纳携带。无论居家还是户外，随时开启身心之旅。',
    tags: ['瑜伽', '便携', '环保', '运动'],
    rating: 4.6,
    reviewCount: 421,
    featured: false,
    inStock: true,
    createdAt: '2026-06-20',
  },
  {
    id: 'p010',
    name: '复古黄铜书签礼盒',
    slug: 'vintage-brass-bookmark-set',
    category: '生活优选',
    price: 198,
    originalPrice: 269,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20set%20of%20vintage%20brass%20bookmarks%20with%20engraved%20Chinese%20patterns%2C%20displayed%20beside%20an%20old%20leather-bound%20book%20on%20a%20wooden%20desk%2C%20warm%20ambient%20light%2C%20product%20photography%20with%20literary%20aesthetic&width=800&height=800&seq=product-p010&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p010',
    imageQuery: 'A set of vintage brass bookmarks with engraved Chinese patterns, displayed beside an old leather-bound book on a wooden desk, warm ambient light, product photography with literary aesthetic',
    description: '黄铜精制，复古做旧工艺。礼盒内含四枚不同纹样书签，是送给爱书之人的绝佳礼物。',
    tags: ['黄铜', '书签', '礼盒', '文创'],
    rating: 4.8,
    reviewCount: 167,
    featured: false,
    inStock: true,
    createdAt: '2026-04-25',
  },
  {
    id: 'p011',
    name: '智能恒温保温杯',
    slug: 'smart-temperature-mug',
    category: '特惠专区',
    price: 239,
    originalPrice: 399,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20sleek%20smart%20temperature-controlled%20insulated%20tumbler%20mug%20in%20matte%20white%20with%20LED%20display%2C%20minimalist%20modern%20design%2C%20product%20photography%20on%20a%20clean%20white%20desk%20with%20coffee%20beans%20scattered&width=800&height=800&seq=product-p011&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p011',
    imageQuery: 'A sleek smart temperature-controlled insulated tumbler mug in matte white with LED display, minimalist modern design, product photography on a clean white desk with coffee beans scattered',
    description: '智能温控技术，12小时持久恒温。LED触屏显示温度，316不锈钢内胆，健康饮水新体验。限时特惠中！',
    tags: ['智能', '保温杯', '恒温', '特惠'],
    rating: 4.7,
    reviewCount: 623,
    featured: true,
    inStock: true,
    createdAt: '2026-07-01',
  },
  {
    id: 'p012',
    name: '天然精油香薰蜡烛礼盒',
    slug: 'essential-oil-candle-gift-set',
    category: '特惠专区',
    price: 268,
    originalPrice: 399,
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20luxury%20gift%20box%20of%20three%20natural%20soy%20wax%20aromatherapy%20candles%20in%20amber%20glass%20jars%2C%20elegant%20packaging%20with%20ribbon%2C%20product%20photography%20on%20marble%20surface%20with%20dried%20flowers&width=800&height=800&seq=product-p012&orientation=squarish',
    imageWidth: 800,
    imageHeight: 800,
    imageSeq: 'product-p012',
    imageQuery: 'A luxury gift box of three natural soy wax aromatherapy candles in amber glass jars, elegant packaging with ribbon, product photography on marble surface with dried flowers',
    description: '三款香型礼盒装：薰衣草安神、柑橘活力、雪松沉稳。天然大豆蜡+植物精油，燃烧纯净无烟。',
    tags: ['蜡烛', '香薰', '礼盒', '特惠'],
    rating: 4.8,
    reviewCount: 289,
    featured: false,
    inStock: true,
    createdAt: '2026-06-10',
  },
];

export const featuredProducts = products.filter(p => p.featured);

export function getProductsByCategory(category: string): Product[] {
  const decoded = decodeURIComponent(category);
  return products.filter(p => p.category === decoded);
}

export function getProductBySlug(slug: string): Product | undefined {
  return products.find(p => p.slug === slug);
}